import { PureComponent } from "react";
import { Icon, Modal } from "office-ui-fabric-react";
import { PrimaryButton } from "office-ui-fabric-react/lib-commonjs";
import React from "react";
import connect from "react-redux/es/connect/connect";
import {
    toggleProjectsAdminModal,
    setProjectsAdminProjects,
} from "../../actions/projects-admin-action";
import UserDetailListComponent from "../ProjectsAdminCrud/UserDetailListComponent";
import ProjectsDetailListComponent from "../ProjectsAdminCrud/ProjectsDetailListComponent";
import "./index.css";
import LoadingScreen from "react-loading-screen";
import { switchRefreshAdminProjects } from "../../actions/generic-globals.actions";

class ProjectsAdminCrudModal extends PureComponent{
    closeModal = () => {
        this.props.toggleProjectsAdminModal(false);
    };

    render() {
        const {
            lang,
            content,
        } = this.props;

        return (
            <div>
                <LoadingScreen
                    className="loadingScreen"
                    loading={this.props.isLoading}
                    bgColor={"rgba(50, 50, 50, 0.2)"}
                    spinnerColor={"#0C92CD"}
                    textColor={"#0C92CD"}
                    text={"Loading"}>
                    <div
                        className="loadingDiv"/>
                </LoadingScreen>
                <Modal
                    isBlocking={false}
                    titleAriaId="titleId"
                    subtitleAriaId="subtitleId"
                    onDismiss={() => this.closeModal()}
                    isOpen={this.props.showProjectsAdminModal}
                    containerClassName="ms-modalExample-container projects-crud-modal"
                >
                    <div id="subtitleId" className="ms-modalExample-body">
                        <div className="ms-Grid" dir="rtl">
                            <div className={"ms-Grid-row projects-modal-header"}>
                                <div className="ms-Grid-col">
                                    <PrimaryButton onClick={this.closeModal} text={content[lang].close}/>
                                </div>
                            </div>
                        </div>
                        <div>
                            {/*TITLE PANEL*/}
                            <div className="ms-Grid" dir="ltr">
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm12 ms-md10 ms-lg6">
                                        <p className="ms-fontSize-xl crud-title ms-fontColor-themeDark ms-normalize">
                                            <Icon iconName="DocumentSet" className="ms-IconExample"/> {content[lang].manageProjectsAdmin}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="list-container">
                                <div className={"ms-Grid-row"}>
                                    <div className={"ms-Col-10"}>
                                        <UserDetailListComponent/>
                                    </div>
                                </div>
                                <div className={"ms-Grid-row"}>
                                    <div className={"ms-Col-10"}>
                                        {
                                            ( () => {
                                                if (this.props.projects.length > 0) {
                                                    return <ProjectsDetailListComponent/>;
                                                }
                                            } )()
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        lang: state.localization.lang,
        content: state.localization.content,
        projects: state.projectsAdmin.projects,
        isLoading: state.projectsAdmin.isLoading,
        showProjectsAdminModal: state.projectsAdmin.showProjectsAdminModal,
    };
};

const mapDispatchToProps = {
    toggleProjectsAdminModal,
    setProjectsAdminProjects,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProjectsAdminCrudModal);



// WEBPACK FOOTER //
// ./src/components/ProjectsAdminCrudModal/index.js